import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenerateEmissionReportComponent } from 'src/app/shared/components/generate-emission-report/generate-emission-report.component';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getmonths, getShipNameOptions, gettypeofreport, getvesselname } from 'src/app/shared/helpers/dropdown-options';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { EmissionService } from 'src/app/shared/service/emission-service/emission.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { MatSort, Sort } from '@angular/material/sort';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
import { isEmzoilVessel, normalizeEmissionVesselClient } from 'src/app/shared/helpers/emission-client-filter.util';

@Component({
  selector: 'app-fuel-eu',
  templateUrl: './fuel-eu.component.html',
  styleUrls: ['./fuel-eu.component.scss']
})
export class FuelEuComponent implements OnInit, OnDestroy {


  @ViewChild(MatSort) sort!: MatSort;

  myreportForm: FormGroup;
  monthOptions: any;
  shipnameoptions: any;
  vesselnameoptions: any;
  typeofreportoptions: string[];

  paginatedData: any[] = [];
  currentPage: number = 0;
  itemsPerPage: number = 100;

  elements: any[] = [];
  // tableData: any[] = [];
  vesselNameSuggestions: any[] = [];

  isLoading: boolean = false;
  selectedReport: string = '';
  username: string = '';
  clientList: string[] = [];
  clientFilters: { [key: string]: (item: any) => boolean } = {
    'Eiger Shipping': (item) => item.client_name === 'Eiger' && !isEmzoilVessel(item),
    'Zeronorth ZN': (item) => item.client_name === 'ZeroNorth',
    'Elite Shipping': (item) =>
      item.client_name === 'Elite' ||
      item.client_name === 'ELITE TANKSHIP DMCC',
    'Bunge Shipping': (item) => item.client_name === 'Bunge',
    'Alcor Shipping': (item) =>
      item.client_name === 'ALCOR CHARTERING DMCC',
    'EMZoil Shipping': (item) =>
      item.client_name === 'EMZ OIL' ||
      item.client_name === 'EMZOIL FZCO' ||
      item.client_name?.toLowerCase().includes('emz') ||
      isEmzoilVessel(item),
    'Ethiopian Shipping & Logistics': (item) =>
      item.client_name?.toLowerCase() === 'ethiopian shipping & logistics',
  };
  tableData: any[] = [
    {
      issue_status: "No issues",
      vessel_name: "",
      ice_class: "None",
      mrv: "EU/UK",
      type: "CO2e (mt)",
      arrived: "1953.5",
      between: "-",
      departed: "1701.9",
      ports: "206.4",
      total: "3861.7",

      hfo: "1019.3",
      mdo_mgo: "195.9",

      total_dist_sailed: "10167.4",
      total_time_sea: "856",
      time_anchorage: "41",
      transport_work: "2200"
    },

    {
      issue_status: "Data ql. issues",
      vessel_name: "",
      ice_class: "None",
      mrv: "EU/UK",
      type: "CO2e (mt)",
      arrived: "1860.2",
      between: "-",
      departed: "1650.1",
      ports: "180.4",
      total: "3515.7",

      hfo: "950.3",
      mdo_mgo: "175.2",

      total_dist_sailed: "9875.4",
      total_time_sea: "810",
      time_anchorage: "37",
      transport_work: "2050"
    }
  ];
  private destroy$ = new Subject<void>();



  reportOptions = [
    { label: 'Average Temp Forecast', value: 'avg_temp_forecast' },
    { label: 'Tank Temp Forecast', value: 'tank_temp_forecast' },
    { label: 'Heat Plan', value: 'heat_plan' },
    { label: 'Bunker Report', value: 'bunker_forecast' }
  ];
  subusername: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private emissionService: EmissionService,
    private commonService: CargoheatingCommonService,
    private router: Router,
    private overlayService: OverlapService,
    private requestFormService: RequestFormService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.myreportForm = this.fb.group({
      vesselname: [''],
      typeofreport: [''],
      from_date: [''],
      to_date: [''],
      month: [''],
      vesselIMO: ['', [Validators.pattern('^[0-9]*$')]],
      client: [''],
    });

    this.username = localStorage.getItem('username') ?? '';

    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.vesselnameoptions = getvesselname();
    this.typeofreportoptions = gettypeofreport();

    this.paginateData();
  }

  ngOnInit(): void {
     this.subusername = localStorage.getItem('loginPic') ?? '';
    this.fetchReportTableData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }

  applyClientFilter(sourceData: any[]) {
    const selectedClient = this.myreportForm.get('client')?.value;

    if (this.username === 'Meraki - Operations') {
      if (selectedClient && this.clientFilters[selectedClient]) {
        this.elements = sourceData.filter(this.clientFilters[selectedClient]);
      } else {
        this.elements = sourceData;
      }
    } else if (this.clientFilters[this.username]) {
      this.elements = sourceData.filter(this.clientFilters[this.username]);
    } else {
      this.elements = sourceData;
    }

    if (this.subusername?.toLowerCase() === 'grace') {
      const graceImos = ['9378876', '9399480', '9438406', '9432048'];
      this.elements = this.elements.filter((item: any) =>
        graceImos.includes(String(item.imo_number ?? item.ship_imo ?? item.imo ?? '').trim())
      );
    }
  }

  fetchReportTableData(isInitialFetch = true, params: any = {}): void {
    this.isLoading = true;

    this.emissionService.getETSVessels(params).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        let vessels = res?.vessels || [];
        vessels.forEach(normalizeEmissionVesselClient);
        if (this.subusername?.toLowerCase() === 'grace') {
          const graceImos = ['9378876', '9399480', '9438406', '9432048'];
          vessels = vessels.filter((v: any) =>
            graceImos.includes(String(v.imo_number ?? v.ship_imo ?? v.imo ?? '').trim())
          );
        }
        if (isInitialFetch) {
          vessels = this.filterAndMaskDemoVoyages(vessels);
          this.vesselNameSuggestions = vessels;
          this.clientList = Object.keys(this.clientFilters).filter((clientKey) => {
            return vessels.some((v: any) => this.clientFilters[clientKey](v));
          });
        }

        const searchResults = vessels || [];
        this.applyClientFilter(searchResults);

        this.currentPage = 0;
        this.paginateData();

        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        console.error(error);
        this.toastr.error('Failed to load Fuel EU table data');
      },
    );
  }
  showDetails(row: any) {
    const imo = row?.original_vessel_imo || row?.imo || row?.imo_number || row?.ship_imo || row?.vessel_imo;
    if (imo) {
      this.router.navigate(['/E-FuelUl-ShipView', imo]);
    } else {
      console.error('IMO number is missing from row data', row);
      this.toastr.warning('Vessel IMO is not available');
    }
  }
  onReportSelect(selectedType: string, row: any) {
    const payload = {
      report_type: selectedType,
      vessel_imo: row.ship_imo,
      hp_number: row.hp_np,
      voyage_no: row.voyage_no,
    };

    this.commonService.printFinalReport(payload).subscribe(
      (response: any) => {
        this.overlayService.showPdf(response);
      },
      () => {
        this.toastr.info(ToasterMessages.RecordNotFount);
      }
    );
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    const isAsc = sort.direction === 'asc';

    this.paginatedData = data.sort((a, b) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];
      if (valueA == null) return isAsc ? -1 : 1;
      if (valueB == null) return isAsc ? 1 : -1;
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    });
  }

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements.slice(startIndex, startIndex + this.itemsPerPage);
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  openGenerateReportPopup(row: any) {
    this.dialog.open(GenerateEmissionReportComponent, {
      width: '560px',
      data: { ...row, reportType: 'FUELEU' },
      disableClose: true,
    });
  }

  filterClick() {
    const from = this.myreportForm.get('from_date')?.value ? new Date(this.myreportForm.get('from_date')?.value) : null;
    const to = this.myreportForm.get('to_date')?.value ? new Date(this.myreportForm.get('to_date')?.value) : null;

    const vesselIMO = this.myreportForm.get('vesselIMO')?.value?.trim() || '';
    const month = this.myreportForm.get('month')?.value || '';
    const vesselName = this.myreportForm.get('vesselname')?.value?.trim() || '';
    const reportType = this.myreportForm.get('typeofreport')?.value?.trim() || '';

    const filtered = this.tableData.filter((row) => {
      const rowDate = row.ingested_time ? new Date(row.ingested_time) : null;

      return (
        (!from || (rowDate && rowDate >= from)) &&
        (!to || (rowDate && rowDate <= to)) &&
        (!month || row.voyage_month === month) &&
        (!vesselIMO || row.ship_imo?.toLowerCase().includes(vesselIMO.toLowerCase())) &&
        (!vesselName || row.ship_name?.toLowerCase().includes(vesselName.toLowerCase())) &&
        (!reportType || row.report_type === reportType)
      );
    });

    this.paginatedData = filtered;
  }

  downloadClick() {
    const parseDate = (dateString: any) => {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${date.getFullYear()}`;
      }
      return '';
    };

    const data = this.paginatedData;

    const csvHeader = 'S.No,Ship Name,Ship IMO,Report Type,Voyage Month,Ingested Time';

    const csvData = data
      .map((row: any, index: number) => {
        const ingested = row.ingested_time ? parseDate(row.ingested_time) : '';
        return `${index + 1},${row.ship_name},${row.ship_imo},${row.report_type},${row.voyage_month},${ingested}`;
      })
      .join('\n');

    const csvContent = `${csvHeader}\n${csvData}`;

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'final_report_data.csv';
    a.click();
  }

  clearClick() {
    this.myreportForm.reset();
    this.fetchReportTableData();
  }

  goBack() {
    this.router.navigate(['/ch-graph']);
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }


  filterShipNames(event: any) {
    const input = event.target.value.toLowerCase();
    this.vesselNameSuggestions = this.vesselnameoptions.filter((item: any) =>
      item.ship_name.toLowerCase().includes(input)
    );
  }
  refreshPageData() {
    this.isLoading = true;
    this.fetchReportTableData();
  }

  printFinalReport(row: any) {
    const payload = {
      vessel_imo: row.ship_imo,
      voyage_no: row.voyage_no
    };

    this.commonService.printFinalReport(payload).subscribe(
      (res: any) => {
        this.overlayService.showPdf(res);
      },
      () => {
        this.toastr.error('Report Not Found');
      }
    );
  }
  private isDemoUser(): boolean {
    const username = (localStorage.getItem('username') || '').toLowerCase();
    const loginPic = (localStorage.getItem('loginPic') || '').toLowerCase();
    const subuser = (this.subusername || '').toLowerCase();
    return subuser === 'demo' || loginPic === 'demo' || username === 'meraki - demo' || username.includes('demo');
  }
    
    private filterAndMaskDemoVoyages(voyages: any[]): any[] {
      if (!this.isDemoUser()) {
        return voyages;
      }
    
      return (voyages || [])
        .filter((v: any) => {
          const imo = String(
            v?.imo_number ??
            v?.ship_imo ??
            v?.imo ??
            ''
          ).trim();
    
          return DEMO_VESSEL_PC.includes(imo);
        })
        .map((v: any) => {
          const imo = String(
            v?.imo_number ??
            v?.ship_imo ??
            v?.imo ??
            ''
          ).trim();
    
          const index = DEMO_VESSEL_PC.indexOf(imo);
    
          return {
            ...v,
             original_vessel_imo: v.imo,
             original_vessel_name: v.vessel_name,
            // Mask vessel name
            vessel_name: `Vessel ${index + 1}`,
            ship_name: `Vessel ${index + 1}`,
            client_name: 'Client 1',
            // Mask IMO
            imo: 'xxxxxxx',
            ship_imo: 'xxxxxxx',
          };
        });
    }
}

